"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = exports.AnalyticsProvider = exports.AnalyticsContext = void 0;
var react_1 = __importStar(require("react"));
var _1 = require(".");
exports.AnalyticsContext = (0, react_1.createContext)(null);
var AnalyticsProvider = /** @class */ (function (_super) {
    __extends(AnalyticsProvider, _super);
    function AnalyticsProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.trackEvent = function (event, data) {
            return _this.state.amp.track(event, data);
        };
        _this.identify = function (user) { return _this.state.amp.identify(user); };
        _this.setUserId = function (userId) { return _this.state.amp.setUserId(userId); };
        _this.state = {
            amp: props.userId ? new _1.DmsAnalytics(props.apiKey, props.userId) : new _1.DmsAnalytics(props.apiKey)
        };
        if (props.userInfo) {
            _this.state.amp.identify(props.userInfo);
        }
        return _this;
    }
    AnalyticsProvider.prototype.render = function () {
        if (!this.state.amp)
            return null;
        return (react_1.default.createElement(exports.AnalyticsContext.Provider, { value: {
                trackEvent: this.trackEvent,
                identify: this.identify,
                setUserId: this.setUserId
            } }, this.props.children));
    };
    AnalyticsProvider.defaultProps = {
        children: react_1.default.createElement("div", null),
        apiKey: "",
    };
    return AnalyticsProvider;
}(react_1.Component));
exports.AnalyticsProvider = AnalyticsProvider;
var useAnalytics = function () {
    var context = (0, react_1.useContext)(exports.AnalyticsContext);
    if (context === null)
        throw new Error('useAnalytics must be used within a <AnalyticsProvider>');
    return context;
};
exports.useAnalytics = useAnalytics;
